import ApiClient from './ApiClient';

class RoleApi extends ApiClient {
  constructor() {
    super('roles', { accountScoped: true });
  }
}

export default new RoleApi();
